import React from "react";
import { Eye } from "@phosphor-icons/react";
import { ActionButton, StatusBadge } from "../app";

export function createQuotationColumns({
  t,
  formatMoney,
  getClientName,
  onViewQuotation,
  statusLabels,
}) {
  return [
    {
      id: "quotation_number",
      header: t("quotationNumber"),
      cellClassName: "font-medium text-[#E2B05E]",
      mobileClassName: "font-medium text-[#E2B05E]",
      render: (quotation) => quotation.quotation_number,
      hideOnMobile: true,
    },
    {
      id: "client",
      header: t("client"),
      cellClassName: "text-[#F3F4F6]",
      render: (quotation) => getClientName(quotation.client_id),
      hideOnMobile: true,
    },
    {
      id: "issue_date",
      header: t("date"),
      cellClassName: "text-[#9CA3AF]",
      mobileClassName: "text-[#9CA3AF]",
      render: (quotation) => quotation.issue_date,
    },
    {
      id: "expiry_date",
      header: t("validUntil"),
      cellClassName: "text-[#9CA3AF]",
      mobileClassName: "text-[#9CA3AF]",
      render: (quotation) => quotation.expiry_date,
    },
    {
      id: "total",
      header: t("total"),
      cellClassName: "font-['Outfit'] font-bold text-[#F3F4F6]",
      mobileClassName: "font-['Outfit'] font-bold text-[#F3F4F6]",
      render: (quotation) => `$${formatMoney(quotation.total)}`,
    },
    {
      id: "status",
      header: t("status"),
      render: (quotation) => (
        <StatusBadge
          value={quotation.status}
          label={statusLabels[quotation.status]}
          statusContext="quotation"
        />
      ),
      hideOnMobile: true,
    },
    {
      id: "actions",
      header: t("actions"),
      actions: true,
      render: (quotation) => (
        <ActionButton
          icon={Eye}
          tone="view"
          iconOnly
          onClick={() => onViewQuotation(quotation)}
          data-testid={`view-quotation-${quotation._id}`}
        />
      ),
    },
  ];
}
